import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, XIcon } from 'lucide-react';
type Buyer = {
  name: string;
  female: boolean;
};
const buyers: Buyer[] = [{
  name: 'Anna K.',
  female: true
}, {
  name: 'Piotr W.',
  female: false
}, {
  name: 'Katarzyna N.',
  female: true
}, {
  name: 'Tomasz Z.',
  female: false
}, {
  name: 'Magdalena S.',
  female: true
}, {
  name: 'Michał L.',
  female: false
}, {
  name: 'Agnieszka P.',
  female: true
}, {
  name: 'Krzysztof D.',
  female: false
}, {
  name: 'Joanna M.',
  female: true
}, {
  name: 'Paweł G.',
  female: false
}, {
  name: 'Aleksandra B.',
  female: true
}, {
  name: 'Marcin J.',
  female: false
}, {
  name: 'Ewa C.',
  female: true
}, {
  name: 'Jakub R.',
  female: false
}, {
  name: 'Natalia K.',
  female: true
}, {
  name: 'Łukasz W.',
  female: false
}, {
  name: 'Monika T.',
  female: true
}, {
  name: 'Bartosz S.',
  female: false
}, {
  name: 'Karolina F.',
  female: true
}, {
  name: 'Adrian M.',
  female: false
}];
// Genitive form, used after "z" ("z Krakowa")
const cities = ['Warszawy', 'Krakowa', 'Wrocławia', 'Poznania', 'Gdańska', 'Łodzi', 'Katowic', 'Szczecina', 'Lublina', 'Bydgoszczy', 'Białegostoku', 'Gdyni', 'Rzeszowa', 'Torunia', 'Kielc', 'Olsztyna', 'Opola', 'Częstochowy', 'Radomia', 'Sopotu'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomMinutes(): number {
  return Math.floor(Math.random() * 15) + 2;
}
/** Polish plural: 2–4 minuty, 5+ minut (12–14 → minut). */
function minutesLabel(n: number): string {
  const lastDigit = n % 10;
  const lastTwo = n % 100;
  if (lastDigit >= 2 && lastDigit <= 4 && (lastTwo < 12 || lastTwo > 14)) return 'minuty';
  return 'minut';
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    female: false,
    city: '',
    minutes: 0
  });
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    function showNotification() {
      const buyer = getRandomItem(buyers);
      setData({
        name: buyer.name,
        female: buyer.female,
        city: getRandomItem(cities),
        minutes: getRandomMinutes()
      });
      setVisible(true);
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        setVisible(false);
      }, 4000);
    }
    // First popup after 15 seconds
    const initialTimeout = setTimeout(showNotification, 15000);
    // Then every 35-50 seconds
    const interval = setInterval(showNotification, 35000 + Math.random() * 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-386" data-mp="2eq65y7m1qg0i">
      {visible && <motion.div initial={{
      opacity: 0,
      x: -40
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -40
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-4 z-[60] max-w-[300px] md:bottom-6" role="status" aria-live="polite" data-id="element-387" data-mp="ffoas59588c9">
          <div className="bg-slate-900/95 backdrop-blur-md rounded-2xl shadow-2xl shadow-black/50 border border-white/10 p-3.5 flex items-start gap-3" data-id="element-388" data-mp="82fefsrhneh3">
            <div className="w-9 h-9 bg-emerald-500/15 rounded-full flex items-center justify-center shrink-0" data-id="element-389" data-mp="3ubghvlyygx9i">
              <ShoppingBag size={17} className="text-emerald-400" aria-hidden="true" data-id="element-390" data-mp="vtuibpywy3ug" />
            </div>
            <div className="min-w-0" data-id="element-391" data-mp="qu869jutmtn8">
              <p className="text-sm font-semibold text-white leading-tight" data-id="element-392" data-mp="qv9ezhod741s">
                {data.name} z {data.city}
              </p>
              <p className="text-xs text-slate-300 mt-0.5" data-id="element-393" data-mp="gwk8el1x560u">
                {data.female ? 'właśnie kupiła' : 'właśnie kupił'}{' '}
                <span className="font-semibold text-sky-400" data-id="element-394" data-mp="36mp25u2jy7dm">
                  Trening Funkcjonalny 365
                </span>
              </p>
              <p className="text-[11px] text-slate-500 mt-1" data-id="element-395" data-mp="31ovsus5ycx94">
                {data.minutes} {minutesLabel(data.minutes)} temu
              </p>
            </div>
            <button onClick={() => setVisible(false)} className="text-slate-500 hover:text-white transition-colors duration-150 ml-auto shrink-0 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400" aria-label="Zamknij powiadomienie" data-id="element-396" data-mp="z2ucx1oh4zqk">
              <XIcon size={14} aria-hidden="true" data-id="element-397" data-mp="1d23lpgacorki" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}